import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Flashcard } from '@/lib/types/flashcard';

interface FlashcardCardProps {
  card: Flashcard;
  isActive: boolean;
}

export function FlashcardCard({ card, isActive }: FlashcardCardProps) {
  const [isFlipped, setIsFlipped] = useState(false);

  if (!isActive) return null;

  return (
    <div 
      className="relative h-[300px] w-full cursor-pointer perspective-1000"
      onClick={() => setIsFlipped(!isFlipped)}
    >
      <AnimatePresence mode="wait">
        {!isFlipped ? (
          <motion.div
            key="front"
            initial={{ rotateY: 180 }}
            animate={{ rotateY: 0 }}
            exit={{ rotateY: -180 }}
            transition={{ duration: 0.3 }}
            className="absolute inset-0 backface-hidden"
          >
            <div className="flex h-full w-full items-center justify-center rounded-xl bg-white p-8 text-center shadow-lg dark:bg-dark-card">
              <h3 className="text-xl font-medium text-gray-900 dark:text-dark-text">
                {card.front}
              </h3>
            </div>
          </motion.div>
        ) : (
          <motion.div
            key="back"
            initial={{ rotateY: -180 }}
            animate={{ rotateY: 0 }}
            exit={{ rotateY: 180 }}
            transition={{ duration: 0.3 }}
            className="absolute inset-0 backface-hidden"
          >
            <div className="flex h-full w-full items-center justify-center rounded-xl bg-white p-8 text-center shadow-lg dark:bg-dark-card">
              <p className="text-lg text-gray-700 dark:text-dark-muted">
                {card.back}
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
} 